"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const TemplateConstants_1 = require("./TemplateConstants");
const store_1 = require("../../store");
exports.openTemplate = (businessId, callback) => {
    store_1.default.dispatch({ type: TemplateConstants_1.TemplateActions.Open, payload: { businessId, callback } });
};
exports.close = () => {
    store_1.default.dispatch({ type: TemplateConstants_1.TemplateActions.Close });
};


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Template/TemplateActions.ts
// module id = 1070
// module chunks = 0 1 2